var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScatterchartThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1082,
    height: 659,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 1082 659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1082,
    height: 659,
    x: 0,
    y: 0,
    id: 0,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 589.5L973.8 589.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 483.5L973.8 483.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 377.5L973.8 377.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 271.5L973.8 271.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 166.5L973.8 166.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 60.5L973.8 60.5",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 60L108.5 589",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M281.5 60L281.5 589",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M454.5 60L454.5 589",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M627.5 60L627.5 589",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 60L800.5 589",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M974.5 60L974.5 589",
    fill: "none",
    stroke: "#E0E6F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 589L108.5 60",
    fill: "none",
    stroke: "#6E7079",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 589.5L973.8 589.5",
    fill: "none",
    stroke: "#6E7079",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 589.5L103.2 589.5",
    fill: "none",
    stroke: "#6E7079"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 483.5L103.2 483.5",
    fill: "none",
    stroke: "#6E7079"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 377.5L103.2 377.5",
    fill: "none",
    stroke: "#6E7079"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 271.5L103.2 271.5",
    fill: "none",
    stroke: "#6E7079"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 166.5L103.2 166.5",
    fill: "none",
    stroke: "#6E7079"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.2 60.5L103.2 60.5",
    fill: "none",
    stroke: "#6E7079"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 589L108.5 594",
    fill: "none",
    stroke: "#6E7079"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M281.5 589L281.5 594",
    fill: "none",
    stroke: "#6E7079"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M454.5 589L454.5 594",
    fill: "none",
    stroke: "#6E7079"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M627.5 589L627.5 594",
    fill: "none",
    stroke: "#6E7079"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M800.5 589L800.5 594",
    fill: "none",
    stroke: "#6E7079"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M974.5 589L974.5 594",
    fill: "none",
    stroke: "#6E7079"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(100.2 589)",
    fill: "#6E7079"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(100.2 483.2)",
    fill: "#6E7079"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(100.2 377.4)",
    fill: "#6E7079"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(100.2 271.6)",
    fill: "#6E7079"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(100.2 165.8)",
    fill: "#6E7079"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(100.2 60)",
    fill: "#6E7079"
  }, "10"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(108.2 597)",
    fill: "#6E7079"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(281.32 597)",
    fill: "#6E7079"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(454.44 597)",
    fill: "#6E7079"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(627.56 597)",
    fill: "#6E7079"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(800.68 597)",
    fill: "#6E7079"
  }, "12"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(973.8 597)",
    fill: "#6E7079"
  }, "15"), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,685.2667,163.684)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,573.8928,221.345)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,858.3867,188.018)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,630.4453,122.951)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,742.9733,148.343)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,916.0933,183.786)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,881.4693,228.751)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,685.2667,254.143)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,916.0933,115.016)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,829.5333,228.222)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,636.216,208.12)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,771.8267,208.12)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,283.0512,365.233)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,812.2213,174.793)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,224.7675,352.537)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,168.792,412.843)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,341.912,326.616)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,456.1712,206.004)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,800.68,257.846)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,800.68,121.364)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,516.7632,281.122)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0A1 1 0 1 1 1 -0.0001",
    transform: "matrix(10,0,0,10,397.8875,288.528)",
    fill: "#5470c6",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterchartThumb);
export default __webpack_public_path__ + "static/media/scatterchart_thumb.3d1c86bd8f04fcec1f32c00126cd9be4.svg";
export { ForwardRef as ReactComponent };